// default app vars
let g_dev = true;
let g_windowHeight = window.offsetHeight;
let g_windowWidth = window.offsetWidth;
let g_scroll = window.pageYOffset;

// custom vars
let scrollMargin = 0;
let scrollTreshold = 0;

window.addEventListener('scroll', function(event){
    g_scroll = window.pageYOffset;
});

window.addEventListener('resize', function(event){
    g_windowHeight = window.offsetHeight;
    g_windowWidth = window.offsetWidth;
});

